import { NgModule } from '@angular/core';
import { PermissionsModule } from './permissions/permissions.module';
import { UserService } from './user.service';
import { StoreModule } from '@ngrx/store';
import { USER_FEATURE, userReducer } from './user.reducer';

@NgModule({
  declarations: [

  ],
  imports: [
    PermissionsModule,
    StoreModule.forFeature(USER_FEATURE, userReducer)
  ],
  providers: [
    UserService
  ]
})
export class UserModule { }
